export const AVAILABLE_ACTIONS_TEST_IDS = {
  TABLE_ACTIONS_DROPDOWN: 'available-actions-dropdown-test-id',
  OPTION_PREFIX: '-option',
};

export const DEPENDENTS_QUANTITY_BLOB_TEST_ID = 'dependents-quantity-blob-test-id';

export const SEND_INVITATION_MODAL_ID = 'send-invitation-modal';

export const WARNING_MODALS_TEST_IDS = {
  REMOVE_EMPLOYEE_MODAL: 'remove-employee-warning-modal-test-id',
};

export const IMQS_PROGRESS_TAG_TEST_IDS = {
  INFO_BUTTON_FILLED: 'info-button-filled-test-id',
  RADIO_BUTTON_CHECKED: 'radio-button-checked-test-id',
  CHECK_CIRCLE: 'check-circle-test-id',
};
